import { chain, omit } from 'lodash';
import * as actions from './actions';

const initialState = {
  initialized: false,
  instances: {},
  instanceLinks: {},
  options: {},
  questions: {},
  responses: {},
  onDeleteInstanceLinks: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onDeleteInstancesSurveyResponses: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchInstances: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchInstanceLinks: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchInstancesQuestions: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchInstancesQuestionsOptions: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onFetchInstancesResponses: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onInitializeCache: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onPostInstanceLinks: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  onPostInstancesResponses: {
    asyncStatus: '',
    message: '',
    status: 0
  }
};

const reducer = (state = initialState, action) => {
  if (action.type === actions.types.ON_DELETE_INSTANCE_LINKS_FULFILLED) {
    const { instanceLinkUUIDs, message, status } = action.data;

    return Object.assign({}, state, {
      instanceLinks: omit(state.instanceLinks, instanceLinkUUIDs),
      onDeleteInstanceLinks: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_DELETE_INSTANCE_LINKS_PENDING) {
    return Object.assign({}, state, {
      onDeleteInstanceLinks: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_DELETE_INSTANCE_LINKS_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onDeleteInstanceLinks: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (
    action.type === actions.types.ON_DELETE_INSTANCES_RESPONSES_FULFILLED
  ) {
    const { surveyResponseUUIDs, message, status } = action.data;

    return Object.assign({}, state, {
      responses: omit(state.responses, surveyResponseUUIDs),
      onDeleteInstancesSurveyResponses: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_DELETE_INSTANCES_RESPONSES_PENDING
  ) {
    return Object.assign({}, state, {
      onDeleteInstancesSurveyResponses: {
        asyncStatus: 'PENDING',
        message: '',
        status: 0
      }
    });
  } else if (
    action.type === actions.types.ON_DELETE_INSTANCES_RESPONSES_REJECTED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onDeleteInstancesSurveyResponses: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCE_LINKS_FULFILLED) {
    const { instanceLinks, message, status } = action.data;

    return Object.assign({}, state, {
      instanceLinks: {
        ...state.instanceLinks,
        ...instanceLinks
      },
      onFetchInstanceLinks: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCE_LINKS_PENDING) {
    return Object.assign({}, state, {
      onFetchInstanceLinks: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCE_LINKS_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchInstanceLinks: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCES_FULFILLED) {
    const { instances, message, status } = action.data;
    return Object.assign({}, state, {
      instances: {
        ...state.instances,
        ...instances
      },
      onFetchInstances: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCES_PENDING) {
    return Object.assign({}, state, {
      onFetchInstances: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_FETCH_INSTANCES_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchInstances: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_FULFILLED
  ) {
    const { options, message, status } = action.data;

    return Object.assign({}, state, {
      options: {
        ...state.options,
        ...options
      },
      onFetchInstancesQuestionsOptions: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_PENDING
  ) {
    return Object.assign({}, state, {
      onFetchInstancesQuestionsOptions: {
        asyncStatus: 'PENDING',
        message: '',
        status: 0
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_REJECTED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchInstancesQuestionsOptions: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_FULFILLED
  ) {
    const { questions, message, status } = action.data;

    return Object.assign({}, state, {
      questions: {
        ...state.questions,
        ...questions
      },
      onFetchInstancesQuestions: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_PENDING
  ) {
    return Object.assign({}, state, {
      onFetchInstancesQuestions: {
        asyncStatus: 'PENDING',
        message: '',
        status: 0
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_REJECTED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchInstancesQuestions: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_RESPONSES_FULFILLED
  ) {
    const { responses, message, status } = action.data;

    return Object.assign({}, state, {
      responses: {
        ...state.responses,
        ...responses
      },
      onFetchInstancesResponses: {
        asyncStatus: 'FULFILLED',
        message,
        status
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_RESPONSES_PENDING
  ) {
    return Object.assign({}, state, {
      onFetchInstancesResponses: {
        asyncStatus: 'PENDING',
        message: '',
        status: 0
      }
    });
  } else if (
    action.type === actions.types.ON_FETCH_INSTANCES_RESPONSES_REJECTED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onFetchInstancesResponses: {
        asyncStatus: 'REJECTED',
        message,
        status
      }
    });
  } else if (action.type === actions.types.ON_INITIALIZE_CACHE_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      initialized: true,
      onInitializeCache: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_INITIALIZE_CACHE_PENDING) {
    return Object.assign({}, state, {
      onInitializeCache: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_INITIALIZE_CACHE_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      initialized: false,
      onInitializeCache: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (action.type === actions.types.ON_POST_INSTANCE_LINKS_FULFILLED) {
    const { instanceLinks, message, status } = action.data;

    return Object.assign({}, state, {
      instanceLinks: {
        ...state.instanceLinks,
        ...instanceLinks
      },
      onPostInstanceLinks: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_POST_INSTANCE_LINKS_PENDING) {
    return Object.assign({}, state, {
      onPostInstanceLinks: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_POST_INSTANCE_LINKS_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onPostInstanceLinks: { asyncStatus: 'REJECTED', message, status }
    });
  } else if (
    action.type === actions.types.ON_POST_INSTANCES_RESPONSES_FULFILLED
  ) {
    const { responses, message, status } = action.data;

    const currentResponsesUUIDs = chain(state.responses)
      .filter(
        responseCurrent =>
          chain(responses)
            .filter(responseNew => {
              const conditionsMatched =
                responseCurrent.surveyLinkUUID === responseNew.surveyLinkUUID &&
                responseCurrent.responseSetDateTime ===
                  responseNew.responseSetDateTime &&
                responseCurrent.responseSetId === responseNew.responseSetId &&
                responseCurrent.instanceLinkUUID ===
                  responseNew.instanceLinkUUID;

              if (
                responseCurrent.responseTypeClass === 'Radio' ||
                !responseNew.optionUUID
              ) {
                return conditionsMatched;
              }

              return (
                responseCurrent.optionUUID === responseNew.optionUUID &&
                conditionsMatched
              );
            })
            .size()
            .value() > 0
      )
      .map('surveyResponseUUID')
      .value();

    const currentResponsesWithRemovedOld = omit(
      state.responses,
      currentResponsesUUIDs
    );

    const responsesNew = chain(responses)
      .map(response =>
        Object.assign({}, response, {
          questionId: response.questionId
        })
      )
      .keyBy('surveyResponseUUID')
      .value();

    return Object.assign({}, state, {
      responses: {
        ...currentResponsesWithRemovedOld,
        ...responsesNew
      },
      onPostInstancesResponses: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (
    action.type === actions.types.ON_POST_INSTANCES_RESPONSES_PENDING
  ) {
    return Object.assign({}, state, {
      onPostInstancesResponses: {
        asyncStatus: 'PENDING',
        message: '',
        status: 0
      }
    });
  } else if (
    action.type === actions.types.ON_POST_INSTANCES_RESPONSES_REJECTED
  ) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      onPostInstancesResponses: { asyncStatus: 'REJECTED', message, status }
    });
  }

  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/qoc-redux/Cache/reducer.js